import { useState } from 'react';
import api from '../../utils/api';

export default function ManageBillingButton({ className }) {
  const [loading, setLoading] = useState(false);

  const openPortal = async () => {
    try {
      setLoading(true);
      const { data } = await api.post('/billing/portal');
      if (!data?.url) {
        throw new Error('Server did not return a billing link.');
      }
      window.location.href = data.url;
    } catch (error) {
      const message = error?.response?.data?.error || error?.message || 'Could not open billing.';
      alert(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button type="button" onClick={openPortal} disabled={loading} className={className}>
      {loading ? 'Opening...' : 'Manage Billing'}
    </button>
  );
}
